// this is an autogenerated file from App/Account/Content/Tasks/New/Content/Board/Content/Main/TasksList/Content/Content/CommentsLogs/Logs/Content/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Tasks_New_Content_Board_Content_Main_TasksList_Content_Content_CommentsLogs_Logs_Content($id: uuid!) {
  tasks_audit_logs(
    where: { task_id: { _eq: $id } }
    order_by: { created_at: desc }
  ) {
    id
    type
    metadata
    created_at
  }
}

`